import Button from '@doordash/component-button'
import { Text, StackChildren, Icon, Colors } from '@doordash/design-language'
import * as React from 'react'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import { IconListCell } from './IconListCell'
import { Container, Bottom, ImageContainer } from './styles'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { SplashImage } from './images/SplashImage'
import * as DA from '../../../typeModules/events'
import t from './strings'

const os = detectWebviewOs()
type MailingAddressSplashProps = {
  primaryAction: () => void
  showDismissButton?: boolean
  track: (
    action: DA.EventActions,
    name: DA.AddressCollectionScreens
  ) => Promise<void>
}

export const MailingAddressSplash: React.FC<MailingAddressSplashProps> = ({
  primaryAction,
  showDismissButton = true,
  track,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.AddressCollectionScreens.Splash)
  }, [track])

  return (
    <Container>
      <ImageContainer>
        <SplashImage />
      </ImageContainer>
      <StackChildren>
        <Text styles={Text.Styles.PageTitle}>{t.splash.title()}</Text>
        <Text color={Colors.SystemGrey80} styles={Text.Styles.Body1}>
          {t.splash.description()}
        </Text>
        <IconListCell icon={Icon.Types.CardLine} string={t.splash.list1()} />
        <IconListCell
          icon={Icon.Types.OrderHotbagLine}
          string={t.splash.list2()}
        />
      </StackChildren>
      <Bottom>
        <StackChildren>
          <Button
            onClick={() => {
              track(
                DA.EventActions.Continue,
                DA.AddressCollectionScreens.Splash
              )
              primaryAction()
            }}
          >
            {t.splash.primaryAction()}
          </Button>
          {showDismissButton && (
            <Button
              type={Button.Types.Tertiary}
              onClick={() => {
                track(DA.EventActions.Close, DA.AddressCollectionScreens.Splash)
                return window.location.assign(
                  os === OsTypes.iOS
                    ? IOS_CLOSE_DEEPLINK
                    : ANDROID_CLOSE_DEEPLINK
                )
              }}
            >
              {t.splash.secondaryAction()}
            </Button>
          )}
        </StackChildren>
      </Bottom>
    </Container>
  )
}

export default MailingAddressSplash
